// Конфигурация для разных сред
const isTest = window.location.hostname.includes("testonline.umc.org.kz");
const isProd = !isTest && window.location.hostname.includes("online.umc.org.kz");

// Базовый URL для API
export const BASE_URL = process.env.REACT_APP_API_URL ||
  (isTest
    ? "https://testonline.umc.org.kz/api"    // Тестовая среда
    : isProd
    ? "https://online.umc.org.kz/api"  // Боевая среда
    : "http://localhost:8080");        // Локальная разработка

// URL для стороннего сервиса заявок
export const REQUESTS_API_URL = process.env.REACT_APP_REQUESTS_API_URL ||
  "https://connect.umc.org.kz/api/external/requests";

// Basic Auth для стороннего сервиса заявок. Задаётся через переменную окружения
// REACT_APP_REQUESTS_API_AUTH (формат "login:password") во время сборки фронтенда.
// ВНИМАНИЕ: любое значение здесь попадает в собранный JS-бандл и доступно в браузере.
// Это не полноценная защита — настоящее решение — проксировать запрос через бэкенд,
// чтобы секрет жил только на сервере. Литерал в исходном коде намеренно убран.
export const REQUESTS_API_AUTH = process.env.REACT_APP_REQUESTS_API_AUTH || "";